import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { isJwtExpired, clearTokenSession } from "../functions/authSession";

const CHECK_INTERVAL_MS = 60 * 1000;

const PUBLIC_PATHS = new Set(["/login", "/signup", "/verification", "/forgot-password"]);

/**
 * Periodically checks whether the Cognito access token has expired.
 * If expired, clears session and redirects to login.
 */
export default function TokenWatchdog() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (PUBLIC_PATHS.has(location.pathname)) return undefined;

    const tick = () => {
      const token = Cookies.get("runner_app");
      if (!token) return;
      if (isJwtExpired(token)) {
        clearTokenSession();
        navigate("/login", { replace: true });
      }
    };

    const id = setInterval(tick, CHECK_INTERVAL_MS);
    return () => clearInterval(id);
  }, [location.pathname, navigate]);

  return null;
}
